import { render, staticRenderFns } from "./RsaParametriVitaliListComponent.vue?vue&type=template&id=505b2484"
import script from "./RsaParametriVitaliListComponent.vue?vue&type=script&lang=js"
export * from "./RsaParametriVitaliListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports